import React, { useContext, useEffect, useState } from 'react';
import {
	buildAuthenticationRequest,
	isAuthServerAvailable,
	getUserAccessToken
} from '@sorted/pkce-oauth';
import { useHistory } from 'react-router-dom';
import SplashPage from '../../components/SplashPage';
import settings from '../../settings';
import UserContext from '../../../context/UserContext';
import buildUserDetails from '../buildUserDetails';

const availabilityMessage = available => {
	if (available === true) {
		return 'Checking credentials, please wait...';
	}

	if (available === false) {
		return 'Cannot contact the authorisation server. Are you connected to the internet?';
	}

	return 'Contacting authorisation server, please wait...';
};

const Login = ({ location }) => {
	const userContext = useContext(UserContext);
	const history = useHistory();
	const [serverAvailable, setServerAvailable] = useState(null);

	const redirectToLogin = async () => {
		const redirectUrl = await buildAuthenticationRequest(
			settings,
			'/auth/login/cb',
			location?.state?.from?.pathname || '/'
		);
		window.location.assign(redirectUrl);
	};

	const checkUserStatus = async () => {
		const authServerAvailable = await isAuthServerAvailable(settings);

		if (authServerAvailable) {
			setServerAvailable(true);

			if (getUserAccessToken()) {
				try {
					const user = await buildUserDetails(settings);
					userContext.setUser(user);
					history.push(location?.state?.from?.pathname || '/');
				} catch {
					await redirectToLogin();
				}
			} else {
				await redirectToLogin();
			}
		} else {
			setServerAvailable(false);
		}
	};

	useEffect(() => {
		checkUserStatus();
	}, []);

	return (
		<SplashPage waiting={serverAvailable !== false}>
			{availabilityMessage(serverAvailable)}
		</SplashPage>
	);
};

export default Login;
